import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverComponent } from './popover.component';
import { DxPopoverModule, DxScrollViewModule } from 'devextreme-angular';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ObserversModule } from '@angular/cdk/observers';

@NgModule({
  declarations: [PopoverComponent],
  imports: [CommonModule, DxPopoverModule, DxScrollViewModule, MatButtonModule, MatIconModule, ObserversModule],
  exports: [PopoverComponent],
})
export class PopoverModule {}
